export default __webpack_public_path__ + "static/cyidAZKi-5f517f5a40c69c71185d174fa991ac17.svg";